<template>
  <div class="homepage-container">
    <div class="buttons-container">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4 p-1">
          <button
            class="btn btn-block my-btn-block"
            @click="showCreateExperienceModal = true"
          >
            Create a new experience
          </button>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1">
          <button
            class="btn btn-block my-btn-block"
            @click="showCreateSpaceModal = true"
          >
            Spaces and Devices
          </button>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1">
          <button class="btn btn-block my-btn-block" @click="exportAllSpaces">
            Export all spaces
          </button>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1">
          <button
            class="btn btn-block my-btn-block"
            @click="showOpenExperienceModal = true"
          >
            Open an existing experience
          </button>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1">
          <button class="btn btn-block my-btn-block">
            Widgets and Applications
          </button>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1">
          <button
            class="btn btn-block my-btn-block"
            @click="exportAllExperiences"
          >
            Export all experiences
          </button>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1">
          <button
            class="btn btn-block my-btn-block"
            @click="showUploadFilesModal = true"
          >
            Upload files
          </button>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1">
          <button class="btn btn-block my-btn-block">Help</button>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1">
          <button
            class="btn btn-block my-btn-block"
            @click="showAboutModal = true"
          >
            About
          </button>
        </div>
      </div>
    </div>

    <CreateExperienceModal
      v-if="showCreateExperienceModal"
      @close="showCreateExperienceModal = false"
      @ok="createExperience"
    />

    <SpaceManagerModal
      v-if="showCreateSpaceModal"
      @close="showCreateSpaceModal = false"
      @create-space="createSpace"
      @edit-space="editSpace"
    />

    <OpenExperienceModal
      v-if="showOpenExperienceModal"
      @close="showOpenExperienceModal = false"
      @ok="editExperience"
    />

    <UploadFilesModal
      v-if="showUploadFilesModal"
      @close="showUploadFilesModal = false"
    />

    <AboutModal v-if="showAboutModal" @ok="showAboutModal = false" />

    <div class="row justify-content-center footer-container">
      <div class="col-12 col-sm-6 col-lg-4 footer-logo">
        <img src="../assets/logoESPAen.png" />
      </div>
      <div class="col-12 col-sm-6 col-lg-4 footer-paragraph">
        Co‐financed by the European Union and Greek national funds through the
        Operational Program Competitiveness, Entrepreneurship and Innovation,
        under the call RESEARCH – CREATE – INNOVATE (project code:Τ1EDK-02095)
      </div>
    </div>
  </div>
</template>

<script>
import CreateExperienceModal from "@/components/modals/CreateExperienceModal";
import SpaceManagerModal from "@/components/modals/SpaceManagerModal";
import OpenExperienceModal from "@/components/modals/OpenExperienceModal";
import UploadFilesModal from "@/components/modals/UploadFilesModal";
import AboutModal from "@/components/modals/AboutModal";
import { mapGetters } from "vuex";
import FileSaver from "file-saver";

export default {
  name: "home",
  components: {
    CreateExperienceModal,
    SpaceManagerModal,
    OpenExperienceModal,
    UploadFilesModal,
    AboutModal,
  },
  computed: {
    ...mapGetters(["allSpaces", "myExperiences"]),
  },
  data() {
    return {
      showCreateExperienceModal: false,
      showOpenExperienceModal: false,
      showCreateSpaceModal: false,
      showAboutModal: false,
      showUploadFilesModal: false,
      chosenExperience: null,
      message: "",
    };
  },
  mounted() {
    this.$store.dispatch({
      type: "setSceneChosenSpace",
      experienceId: 0,
      spaceObj: this.allSpaces[0],
    });
  },
  methods: {
    createSpace(spaceName) {
      this.showCreateSpaceModal = false;
      let newId = this.allSpaces[this.allSpaces.length - 1].id + 1;
      let spaceObj = {
        id: newId,
        title: spaceName,
        nodes: [],
        links: [],
      };
      ///////////////////////////////////////////////////////////////////
      this.$store
        .dispatch({
          type: "editSpace",
          spaceObj: spaceObj,
        })
        .then((response) => {
          this.$router.push({ path: "space_overview" });
        });
    },
    editSpace(spaceIndex) {
      this.showCreateSpaceModal = false;
      let spaceObj = this.allSpaces[spaceIndex];
      this.$store
        .dispatch({
          type: "editSpace",
          spaceObj: spaceObj,
        })
        .then((response) => {
          this.$router.push({ path: "space_overview" });
        });
    },
    createExperience(data) {
      this.showCreateExperienceModal = false;
      this.$store
        .dispatch({
          type: "editScene",
          sceneObj: data,
        })
        .then((response) => {
          this.$router.push({ path: "experience_overview" });
        });
    },
    editExperience(sceneIndex) {
      let sceneObj = this.myExperiences[sceneIndex];
      this.$store
        .dispatch({
          type: "editScene",
          sceneObj: sceneObj,
        })
        .then((response) => {
          this.$router.push({ path: "experience_overview" });
        });
    },
    exportAllSpaces() {
      console.log("export all spaces");
      var json = JSON.stringify(this.allSpaces);
      var file = new File([json], "allSpaces.json", {
        type: "text/json;charset=utf-8",
      });
      FileSaver.saveAs(file);
    },
    exportAllExperiences() {
      console.log("export all experiences");
      var json = JSON.stringify(this.myExperiences);
      var file = new File([json], "myExperiences.json", {
        type: "text/json;charset=utf-8",
      });
      FileSaver.saveAs(file);
    },
  },
};
</script>

<style scoped type="text/css">
.homepage-container {
  width: 100%;
  height: 100%;
  text-align: center;
  padding-top: 80px;
  overflow-y: auto;
  overflow-x: hidden;
}

.buttons-container {
  width: 80vw;
  margin: 0 auto;
}

.button-row {
  flex-wrap: wrap;
  align-items: flex-start;
  flex-direction: row;
}

.my-btn-block {
  color: inherit;
  height: 140px;
  min-width: 200px;
  padding: 0 20px;
  background-color: #5cc1a6;
  border: 4px solid #5cc1a6;
  border-radius: 4px;
  font-family: inherit;
  font-size: calc(16px + (28 - 16) * ((100vw - 300px) / (1600 - 300)));
  /*line-height: calc(12px + (28 - 14) * ((100vw - 300px) / (1600 - 300)));*/
  font-weight: 500;
  cursor: pointer;
}

.my-btn-block:hover {
  background-color: white;
  color: #5cc1a6;
  transition: 0.3s ease;
}

.my-btn-block:focus {
  color: #5cc1a6;
  background-color: #edf8f5;
}

.footer-container {
  position: absolute;
  left: 0;
  bottom: 10px;
  align-items: center;
  width: 100%;
}

.footer-logo img {
  width: 85%;
  min-width: 280px;
  max-width: 400px;
  display: block;
  margin: auto;
}

.footer-paragraph {
  font-size: 12px;
  font-style: italic;
  text-align: left;
}

@media screen and (max-width: 960px) {
  .buttons-container {
    width: 90vw;
  }
}

@media screen and (max-width: 768px) {
  .footer-container {
    height: 80px;
  }

  .my-btn-block {
    color: inherit;
    height: 100px;
    min-width: 100px;
    padding: 0 20px;
  }
}

@media screen and (max-width: 576px) {
  .footer-container {
    position: unset;
    padding-top: 20px;
  }

  .footer-paragraph {
    padding: 15px 30px;
    text-align: center;
  }
}
</style>
